import { useMediaQuery } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";

import useIsDesktopBrowserLayout from "./useIsDesktopBrowserLayout";
import isEquipeChatMobileApp from "../utils/isEquipeChatMobileApp";
import isEquipeChatDesktopShell from "../utils/isEquipeChatDesktopShell";

const useIsDesktopAppLayout = () => {
  const theme = useTheme();
  const isDesktopBrowserLayout = useIsDesktopBrowserLayout();
  const isDesktopScreen = useMediaQuery(theme.breakpoints.up("md"));

  if (isEquipeChatDesktopShell()) {
    return true;
  }

  if (isEquipeChatMobileApp()) {
    return false;
  }

  return isDesktopBrowserLayout || isDesktopScreen;
};

export default useIsDesktopAppLayout;
